import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { ReactNode } from 'react';

interface RequireAuthProps {
  slug: string;
  children: ReactNode;
}

/**
 * Schützt eine Route: zeigt einen Loader, solange `auth/me` läuft, und leitet
 * sonst auf `/auth` um, wobei die ursprüngliche Ziel-URL als `from` mitgegeben
 * wird, damit Login zurück navigieren könnte (Phase-2-Feature, hier vorbereitet).
 */
export function RequireAuth({ slug, children }: RequireAuthProps) {
  const { isLoading, isAuthenticated } = useAuth(slug);
  const location = useLocation();

  if (isLoading) {
    return <div className="loading">Lade…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
